import { RouteGroup } from '@/modules/core/app/constants/api.constants';

export const ALL = 'all';
export const IMPORT_WIZARD_START_SERVICE_ID = 1000000;
export const TAP_ORDERS_SERVICE_ID = 299;

export const ManageServiceFilterType = {
  ALL,
  CONNECTED: 'connected',
  NOT_CONNECTED: 'not_connected',
};

export const ManageServiceFilterOptions = [
  {
    type: ManageServiceFilterType.ALL,
    label: i18n.$t('Show All'),
    icon: '',
  },
  {
    type: ManageServiceFilterType.CONNECTED,
    label: i18n.$t('Connected'),
    icon: 'ti-flash-fill',
  },
  {
    type: ManageServiceFilterType.NOT_CONNECTED,
    label: i18n.$t('Not connected'),
    icon: '',
  },
];

export const ImportWizardTemplateFilterType = {
  ALL,
  PARTNER: 'partner',
  DELIVERY: 'delivery',
};

export const ConnectionType = {
  OAUTH: 1,
  FORM_FIELDS: 2,
  FTP_DUMP: 3,
  MANUAL: 4,
  LIVE_CONNECTOR: 5,
};

export const DataConnectionType = {
  MASTER: 1,
  INDIVIDUAL_COMBINED: 3,
};

export const OAuthType = {
  TAP_API: 'TapAPI',
  GOOGLE_BIG_QUERY: 'Google BigQuery',
};

export const ManageServicePathName = {
  SUP_MANAGE_SERVICE: 'supmanageservice',
  SUP_SERVICE_MANAGE_CONNECTION: 'supservicemanageconnection',
  SUP_MANAGE_CONNECTIONS: 'supmanageconnections',
  SUP_MANAGE_SERVICE_ACCOUNTS: 'supmanageserviceaccounts',
};

export const ManageServicePath = '/sup/service/manage';

export const ManageServiceEvent = {
  SHOW_MDS_UPGRADE_BANNER: 'showmdsupgradebanner',
  ATTRIBUTE: 'datasource',
};

export const UPGRADE_ROUTE = `/${RouteGroup.BILLING_MANAGEPLANS}`;
export const UPGRADE_ROUTE_CUSTOM = `/${RouteGroup.BILLING_OVERVIEW}`;

export const ManageServiceAccountEvent = {
  SHOW_MDS_ACCOUNT_UPGRADE_BANNER: 'showmdsaccountupgradebanner',
  ATTRIBUTE: 'accounts_per_datasource',
};

export const RestrictedServiceIds = ['46', '191', '211'];

export const NoAutoRefreshServiceIds = [
  '172',
  '69',
  '85',
  '170',
  '39',
  '56',
  '184',
  '96',
  '263',
  '290',
  '123',
  '155',
  '273',
  '292',
  '2',
  '240',
  '296',
  '271',
  '272',
];
